import React, { useEffect, useState } from 'react';
import { Box, Text } from 'pcln-design-system';
import { hotelSummaryManager } from '../generateHotelSummary';
import { useChatMessagesContext } from '../../hooks/useChatMessagesContext';
export const HotelAISummary = ({
  shouldDisplayGenHotelFeature,
  propertyName,
  isExpressDeal,
  fetchRequestOptions,
  description,
  starRating,
  hotelAmenities,
  petDescription
}) => {
  const [summary, setSummary] = useState('');
  const {
    chatMessages
  } = useChatMessagesContext();
  useEffect(() => {
    let intervalId;
    let mounted = true;
    if (!isExpressDeal && shouldDisplayGenHotelFeature && propertyName) {
      const hotelDetail = {
        hotelName: propertyName,
        description,
        starRating,
        hotelFeatures: hotelAmenities === null || hotelAmenities === void 0 ? void 0 : hotelAmenities.map(feature => feature.name),
        petPolicy: petDescription
      };
      hotelSummaryManager.addHotelSummary(propertyName, {
        prompts: chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.filter(msg => !!msg.content),
        source: 'newHotelListingCard',
        fetchRequestOptions,
        hotelDetail
      });
      const checkSummary = () => {
        const summaryResult = hotelSummaryManager.getHotelSummary(propertyName);
        // To make sure the component is still mounted as the time of summary check
        if (mounted) {
          if ((summaryResult === null || summaryResult === void 0 ? void 0 : summaryResult.status) !== 'ERROR') {
            setSummary((summaryResult === null || summaryResult === void 0 ? void 0 : summaryResult.text) || '');
          } else {
            setSummary('');
          }
          if ((summaryResult === null || summaryResult === void 0 ? void 0 : summaryResult.status) === 'DONE' || (summaryResult === null || summaryResult === void 0 ? void 0 : summaryResult.status) === 'ERROR') {
            if (intervalId) {
              clearInterval(intervalId);
            }
          }
        }
      };
      // Initial check
      checkSummary();
      // Start polling
      intervalId = setInterval(checkSummary, 200);
    }
    return () => {
      mounted = false;
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [propertyName, isExpressDeal, shouldDisplayGenHotelFeature, description, starRating, hotelAmenities, petDescription, fetchRequestOptions]);
  if (!summary) {
    return null;
  }
  return React.createElement(Box, {
    "data-testid": 'hotel-ai-summary'
  }, React.createElement(Text, {
    fontSize: 0,
    lineHeight: '20px',
    pb: 1,
    pt: 2
  }, summary));
};
export const HotelAISummaryMemo = React.memo(HotelAISummary, (prev, next) => {
  return prev.propertyName === next.propertyName;
});
HotelAISummaryMemo.displayName = 'HotelAISummary';